import { css } from 'styled-components';

export const inputAndPickerBorderStyle = css`
    ${({ theme }) => css`
        border: 1px solid ${theme.colors.primary.primary4};
    `}
`;
